/**
 * @typedef {Object} UserInfoDto
 * @property {string} sub
 * @property {string} name
 * @property {string} email
 * @property {string} [orgId]
 * @property {string} [orgName]
 * @property {string} [homeOrgId]
 */

export default function (instance) {
  return {
    /**
     * Get current user's profile including current/home organization
     * @returns {Promise<{data: UserInfoDto}>}
     */
    getOrgInfo() {
      return instance.get('connect/userinfo');
    },

    /**
     * Invite a user by email into the current org, returns a shareable link
     * @param {string} email
     * @returns {Promise<{data: {inviteLink: string}}>}
     */
    inviteMember(email) {
      return instance.post('org/invite', { email });
    },

    /**
     * List accepted members and pending invites for the current org
     * @returns {Promise<{data: {members: Array<{userId: string, email: string, name: string}>, pendingInvites: Array<{inviteId: string, inviteeEmail: string, createdDate: string}>}}>}
     */
    getOrgMembers() {
      return instance.get('org/members');
    },

    /**
     * Leave the current org and return to the caller's home org
     * @returns {Promise<{data: {message: string, orgId: string, orgName: string}}>}
     */
    leaveOrg() {
      return instance.post('org/leave');
    },

    /**
     * Revoke all of the current user's refresh tokens server-side. Call
     * before signoutRedirect() so a captured refresh token can't outlive
     * the "logged out" session.
     * @returns {Promise<{data: {message: string}}>}
     */
    revokeSession() {
      return instance.post('connect/revoke');
    }
  };
}
